import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCarePackageDetailsBlockData from '../../.../../../Models/Content/SelfCarePackageDetailsBlockData';
import SelfCarePackagesMain from './selfCarePackagesMain';

export default class SelfCarePackageDetailsBlock extends EpiComponent<SelfCarePackageDetailsBlockData> {
  constructor(props) {
    super(props);
  }
  public render(): ReactNode | ReactNodeArray | null {
    return <SelfCarePackagesMain context={this.getContext()} iContent={this.props.data} />;
  }
}
